import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import type { GlobalSearchEmitPayload } from "@zapier/global-search";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export function useEmitGlobalSearchInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (payload: GlobalSearchEmitPayload) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: payload.eventAction ?? "click",
        interactionName: UserInteractionName.GlobalSearch,
        optionSelected: payload.event,
        interactionRawText: payload.text ?? "",
        interactionGoal: payload.section ?? "",
        customTrackingFields: payload.customData,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return { emit };
}
